import BaseStore from "./BaseStore";

class PermissionsStore extends BaseStore {
  addPermission(user, permission, op) {
    return this.axios.put("global_settings/grant_permission", { user_id: user, permission: permission, needs_approval: String(op)});
  }

  editPermission(user, needs_approval) {
    return this.axios.put("global_settings/edit_permission", { user_id: user, needs_approval: needs_approval});
  }

  removePermission(user, permission) {
    return this.axios.put("global_settings/revoke_permission", { user_id: user, permission: permission });
  }

  listUsers(type) {
    return this.axios.get("/global_settings/list_permissions/",{ params:{ permission: type }});
  }
}

export default new PermissionsStore();



// WEBPACK FOOTER //
// ./src/stores/PermissionsStore.js